@let selectedCollars = selectedCollarsAndGroups$ | async;
<vectronic-card
  [title]="getTitle(selectedCollars)"
  [displayClose]="true"
  (closed)="onClose()"
  [showResize]="true"
  (resized)="onResized($event)"
>
  <div
    class="card-body remote-command"
    body
    [ngClass]="{ 'remote-command--fullscreen': isFullScreen }"
  >
    @if (isLoading()) {
      <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
    }
    @if (!data?.readonly && !isConfirmed() && !isLoading()) {
      <div class="remote-command__row textarea">
        <div
          class="remote-command__row-title"
          [attr.data-testid]="'collars-groups-dialog-button'"
          (click)="onClickedSelectCollar()"
          id="collars-groups-dialog-button"
        >
          <span
            [matBadge]="selectedCollars?.length || undefined"
            matBadgeOverlap="false"
            matBadgeColor="accent"
          >
            To
          </span>
        </div>
        <mat-form-field class="example-chip-list" appearance="outline">
          <mat-chip-grid
            #chipList
            aria-label="Collars"
            [attr.data-testid]="'chips-collars-groups'"
            id="chips-collars-groups"
          >
            @for (collar of selectedCollars; track collar; let i = $index) {
              @if (showMore || i < 1) {
                <mat-chip-row
                  class="example-chip-list__chip"
                  (removed)="!data?.isTerminal && onRemoveCollarAndGroup(collar)"
                  [matTooltip]="getTooltip(collar)"
                  [disabled]="data?.readonly || data?.isTerminal"
                >
                  {{ collar.collarId || collar.group?.name }}
                  @if (collar.group) {
                    <mat-icon class="remote-command__group-icon" svgIcon="object-multi-group">
                    </mat-icon>
                  }
                  @if (showMore && !data?.isTerminal) {
                    <button matChipRemove>
                      <mat-icon class="example-chip-list__delete" color="warn">cancel</mat-icon>
                    </button>
                  }
                </mat-chip-row>
              }
            }
            @if (!showMore && selectedCollars?.length > 1) {
              <mat-chip-row class="example-chip-list__chip">
                +{{ selectedCollars?.length - 1 }}
              </mat-chip-row>
            }
            <div class="example-chip-list__input-container">
              @if (showMore && !data?.isTerminal) {
                <input
                  class="example-chip-list__input"
                  #collarInput
                  placeholder="Add collar"
                  [formControl]="collarCtrl"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add()"
                  (keyup)="onKeyUp($event)"
                  (paste)="onPaste($event)"
                  [matAutocomplete]="collarAuto"
                  [disabled]="data?.readonly"
                  [attr.data-testid]="'add-collar-input'"
                />
                <mat-autocomplete
                  #collarAuto="matAutocomplete"
                  (optionSelected)="onCollarSelected($event)"
                >
                  @for (c of filteredCollars$ | async; track c.id) {
                    <mat-option [value]="c.id">
                      {{ c.id }}
                    </mat-option>
                  }
                </mat-autocomplete>
              }
            </div>
          </mat-chip-grid>
        </mat-form-field>
      </div>
    }
    @if (
      (remoteCommandsService.isMaxParametersReached() ||
        remoteCommandsService.isMaxSchedulesReached()) &&
      !data?.readonly &&
      !isConfirmed() &&
      !isLoading()
    ) {
      <vectronic-alert type="info">
        Please note that for {{ collarsWithShortHeaderFormatJoin() }}, schedules and parameter
        changes must be sent in separated commands
      </vectronic-alert>
    }
    @if (!canSendCommands()) {
      <vectronic-alert type="error">
        Sending remote commands require Device Manager permission or higher!
      </vectronic-alert>
    }
    @if (
      !data?.isTerminal &&
      remoteCommandsService.isGlobalstarSelected() &&
      !data?.readonly &&
      !isConfirmed()
    ) {
      <vectronic-alert type="error">Globalstar does not provide Remote Commands.</vectronic-alert>
    }
    @if (isConfirmed()) {
      <div>
        <vectronic-alert type="success">
          {{
            data?.isTerminal
              ? 'The command has been written to the terminal successfully!'
              : 'The remote command has been sent to the server successfully!'
          }}
        </vectronic-alert>
        <div class="remote-command__ids">
          <strong>IDs:</strong>
          {{ (remoteCommandsService.selectedCollarIds$ | async)?.join(', ') }}
        </div>
      </div>
    }
    @if (
      (remoteCommandsService.selectedCollarIds$ | async)?.length &&
      !isLoading() &&
      canSendCommands()
    ) {
      @let userOrFactoryValue = remoteCommandsService.userOrFactory$ | async;
      <vectronic-parameter-view
        [parameters]="filteredParameters$ | async"
        [categories]="categories$ | async"
        [subsystems]="subsystems$ | async"
        [viewType]="'tab'"
        [isEditable]="!isConfirmed() && !data?.readonly"
        [deviceTypeParameterConfigWithAvailableList]="
          remoteCommandsService.deviceTypeParameterConfig$ | async
        "
        [collarIds]="remoteCommandProviderService.selectedCollarIds()"
        [categoryTitles]="configCategoryTitles()"
        [showReload]="false"
        [showReset]="!isConfirmed() && !data?.readonly"
        [showFactory]="!isConfirmed() && !data?.readonly"
        [showInfo]="false"
        (clear)="onClear()"
        [presetPatternParameter]="parametersIdentifierService.presetPatternParameter$ | async"
        [showClear]="!isConfirmed() && !data?.readonly"
        [customCategoryCounts]="customCategoryCounts$ | async"
        [basicOrAdvanced]="remoteCommandsService.basicOrAdvanced$ | async"
        [userOrFactory]="userOrFactoryValue"
        [isMaxParametersReached]="
          remoteCommandsService.isMaxParametersReached() || scheduleServices.hasAnyEmptySchedule()
        "
        [isChanged]="isChanged()"
        [hideChangedParameterData]="isConfirmed() || data?.readonly"
        [userSubsystemVisibility]="userSubsystemVisibility()"
        [userAccess]="userAccess"
        [isRemote]="remoteCommandProviderService.isRemote()"
        [warningByParameterId]="warningByParameterId()"
        [errorByParameterId]="errorByParameterId()"
        [disabledByParameterId]="disabledByParameterId()"
        (changeCategory)="onChangeCategory($event)"
        [isFilled]="isFilled()"
      >
        <ng-template #gpsCategory>
          <rc-schedule-view
            [readonly]="isConfirmed() || data?.readonly"
            [isConfirmation]="isConfirmed()"
            [selectedCollarIds]="remoteCommandsService.selectedCollarIds$ | async"
            (clear)="onClear()"
            (resetToDefaultPolygons)="resetToDefaultPolygons()"
            [showClear]="false"
            [showRemoveSchedule]="false"
            [shouldUpdateSchedules]="true"
            [videoFormatsOptions]="camerasFormatService.videoFormatsOptions$ | async"
            [photoFormatsOptions]="camerasFormatService.photoFormatsOptions$ | async"
            [defaultVirtualFenceConstructionRules]="virtualFenceRules"
            [isRulesDeletable]="true"
            [onlyShow]="['GPS']"
            [showScheduleRemove]="false"
            [permanentStartDate]="'2000-01-01'"
            [permanentEndDate]="permanentEndDate$ | async"
            [permanentEndDateByCollar]="permanentEndDateByCollar$ | async"
            [showLoadFromTemplates]="true"
            [(showPreview)]="showPreview"
          ></rc-schedule-view>
        </ng-template>
        <ng-template #beaconCategory>
          <rc-schedule-view
            [readonly]="isConfirmed() || data?.readonly"
            [isConfirmation]="isConfirmed()"
            [selectedCollarIds]="remoteCommandsService.selectedCollarIds$ | async"
            (clear)="onClear()"
            (resetToDefaultPolygons)="resetToDefaultPolygons()"
            [showClear]="false"
            [showRemoveSchedule]="false"
            [shouldUpdateSchedules]="true"
            [videoFormatsOptions]="videoFormatsOptions$ | async"
            [photoFormatsOptions]="photoFormatsOptions$ | async"
            [defaultVirtualFenceConstructionRules]="virtualFenceRules"
            [isRulesDeletable]="true"
            [onlyShow]="['VHF']"
            [showScheduleRemove]="false"
            [permanentStartDate]="'2000-01-01'"
            [permanentEndDate]="permanentEndDate$ | async"
            [permanentEndDateByCollar]="permanentEndDateByCollar$ | async"
            [showLoadFromTemplates]="true"
            [(showPreview)]="showPreview"
          ></rc-schedule-view>
        </ng-template>
        <ng-template #cameraCategory>
          <rc-schedule-view
            [readonly]="isConfirmed() || data?.readonly"
            [isConfirmation]="isConfirmed()"
            [selectedCollarIds]="remoteCommandsService.selectedCollarIds$ | async"
            (clear)="onClear()"
            (resetToDefaultPolygons)="resetToDefaultPolygons()"
            [showReset]="true"
            [showRemoveSchedule]="true"
            [shouldUpdateSchedules]="true"
            [videoFormatsOptions]="videoFormatsOptions$ | async"
            [photoFormatsOptions]="photoFormatsOptions$ | async"
            [defaultVirtualFenceConstructionRules]="virtualFenceRules"
            [isRulesDeletable]="true"
            [onlyShow]="['CAMERA']"
            [hasMultipleCameraTypes]="hasMultipleCameraTypes()"
            [hasHighActivityCameraTrigger]="remoteCommandsService.hasHighActivityCameraTrigger()"
            [showScheduleRemove]="false"
            [showLoadFromTemplates]="true"
            [(showPreview)]="showPreview"
          ></rc-schedule-view>
        </ng-template>
        <ng-template #communicationCategory>
          <rc-schedule-view
            [readonly]="isConfirmed() || data?.readonly"
            [isConfirmation]="isConfirmed()"
            [selectedCollarIds]="remoteCommandsService.selectedCollarIds$ | async"
            (clear)="onClear()"
            (resetToDefaultPolygons)="resetToDefaultPolygons()"
            [showClear]="false"
            [showRemoveSchedule]="true"
            [shouldUpdateSchedules]="true"
            [videoFormatsOptions]="videoFormatsOptions$ | async"
            [photoFormatsOptions]="photoFormatsOptions$ | async"
            [defaultVirtualFenceConstructionRules]="virtualFenceRules"
            [isRulesDeletable]="true"
            [onlyShow]="['COMMUNICATION']"
            [showScheduleRemove]="false"
            [permanentStartDate]="'2000-01-01'"
            [permanentEndDate]="permanentEndDate$ | async"
            [permanentEndDateByCollar]="permanentEndDateByCollar$ | async"
            [showLoadFromTemplates]="true"
            [(showPreview)]="showPreview"
          ></rc-schedule-view>
        </ng-template>
        <ng-template #vfCategory>
          <rc-schedule-view
            [readonly]="isConfirmed() || data?.readonly"
            [isConfirmation]="isConfirmed()"
            [selectedCollarIds]="remoteCommandsService.selectedCollarIds$ | async"
            (clear)="onClear()"
            (resetToDefaultPolygons)="resetToDefaultPolygons()"
            [showClear]="false"
            [showRemoveSchedule]="true"
            [shouldUpdateSchedules]="true"
            [videoFormatsOptions]="videoFormatsOptions$ | async"
            [photoFormatsOptions]="photoFormatsOptions$ | async"
            [defaultVirtualFenceConstructionRules]="virtualFenceRules"
            [isRulesDeletable]="true"
            [onlyShow]="['VIRTUAL_FENCE']"
            [showScheduleRemove]="false"
            [permanentStartDate]="'2000-01-01'"
            [permanentEndDate]="permanentEndDate$ | async"
            [showVfModeWarning]="true"
            [showLoadFromTemplates]="true"
            [(showPreview)]="showPreview"
          ></rc-schedule-view>
        </ng-template>
        <ng-template #vfMapCategory>
          <rc-schedule-view
            [readonly]="isConfirmed() || data?.readonly"
            [isConfirmation]="isConfirmed()"
            [selectedCollarIds]="remoteCommandsService.selectedCollarIds$ | async"
            [isPositionsLoading]="isPositionsLoading()"
            [mapPositions]="mapPositions()"
            [userPreferences]="mapPreferences()"
            (loadPositions)="onLoadPositions($event)"
            (clear)="onClear()"
            (resetToDefaultPolygons)="resetToDefaultPolygons()"
            [showClear]="false"
            [showRemoveSchedule]="false"
            [shouldUpdateSchedules]="true"
            [videoFormatsOptions]="videoFormatsOptions$ | async"
            [photoFormatsOptions]="photoFormatsOptions$ | async"
            [defaultVirtualFenceConstructionRules]="virtualFenceRules"
            [isRulesDeletable]="true"
            [onlyShow]="['VIRTUAL_FENCE_MAP']"
            [isAdmin]="isAdmin"
            [showScheduleRemove]="false"
            [permanentStartDate]="'2000-01-01'"
            [permanentEndDate]="permanentEndDate$ | async"
            [showVfModeWarning]="true"
            [virtualFenceNotAvailableForIds]="virtualFenceNotAvailableForIds()"
          ></rc-schedule-view>
        </ng-template>
        <ng-template #proximityCategory>
          <rc-schedule-view
            [readonly]="isConfirmed() || data?.readonly"
            [isConfirmation]="isConfirmed()"
            [selectedCollarIds]="remoteCommandsService.selectedCollarIds$ | async"
            (clear)="onClear()"
            (resetToDefaultPolygons)="resetToDefaultPolygons()"
            [showClear]="false"
            [showRemoveSchedule]="true"
            [shouldUpdateSchedules]="true"
            [videoFormatsOptions]="videoFormatsOptions$ | async"
            [photoFormatsOptions]="photoFormatsOptions$ | async"
            [defaultVirtualFenceConstructionRules]="virtualFenceRules"
            [isRulesDeletable]="true"
            [onlyShow]="['PROXIMITY']"
            [showScheduleRemove]="false"
            [permanentStartDate]="'2000-01-01'"
            [permanentEndDate]="permanentEndDate$ | async"
            [showLoadFromTemplates]="true"
            [(showPreview)]="showPreview"
          ></rc-schedule-view>
        </ng-template>
        <ng-template #solexGpsCategory>
          <rc-schedule-view
            [readonly]="isConfirmed() || data?.readonly"
            [isConfirmation]="isConfirmed()"
            [selectedCollarIds]="remoteCommandsService.selectedCollarIds$ | async"
            (clear)="onClear()"
            (resetToDefaultPolygons)="resetToDefaultPolygons()"
            [showClear]="false"
            [showRemoveSchedule]="false"
            [shouldUpdateSchedules]="true"
            [videoFormatsOptions]="videoFormatsOptions$ | async"
            [photoFormatsOptions]="photoFormatsOptions$ | async"
            [defaultVirtualFenceConstructionRules]="virtualFenceRules"
            [isRulesDeletable]="true"
            [onlyShow]="['SOLEX_GPS']"
            [showScheduleRemove]="false"
            [permanentStartDate]="'2000-01-01'"
            [permanentEndDate]="permanentEndDate$ | async"
            [showLoadFromTemplates]="true"
            [(showPreview)]="showPreview"
          ></rc-schedule-view>
        </ng-template>
        <ng-template #dropOffCategory>
          <rc-dropoff-schedule
            [readonly]="data?.readonly || isConfirmed()"
            (addShare)="onAddShare($event)"
            (editShare)="onEditShare($event)"
            (deleteShare)="onDeleteShare($event)"
            [collarsWithNoShortHeaderFormat]="
              remoteCommandsService.collarsWithNoShortHeaderFormat()
            "
            [dropOffIds]="allDropOffIds$ | async"
            [selectedDropOffData$]="dropOffCommandService.selectedDropOffData$"
            [selectedDropOffsIds]="dropOffCommandService.selectedCollarsIds"
            [isDropOffEnabled]="dropOffCommandService.isEnabled()"
            [devicesWithoutRadioControl]="dropOffCommandService.devicesWithoutRadioControl()"
            [devicesWithoutDeviceManagerPermission]="
              dropOffCommandService.devicesWithoutDeviceManagerPermission()
            "
            (remove)="onRemove($event)"
            (addDropOff)="onAddDropOff($event)"
            [isMaxDropOffsReached]="remoteCommandsService.isMaxDropOffsReached()"
            (submitFireDropOff)="onSubmitFireDropOff()"
            [fireDropOffTooltip]="
              deviceCommandResponse()?.DROP_OFF_RELEASE?.length ||
              deviceCommandResponse()?.DROP_OFF_RELEASE_LONG?.length
                ? 'Fire Drop Off for selection'
                : 'The DropOff does not have radio firing enabled'
            "
          ></rc-dropoff-schedule>
        </ng-template>
      </vectronic-parameter-view>
    } @else if (!(remoteCommandsService.selectedCollarIds$ | async)?.length) {
      Please select one or more collars!
    }
  </div>
  <ng-template #cardButtons>
    @if (!data?.readonly && !isConfirmed() && !isLoading()) {
      @if (showUserOrFactoryToggle()) {
        <div class="remote-command__userOrFactory">
          <mat-button-toggle-group
            [ngModel]="remoteCommandsService.userOrFactory$ | async"
            (ngModelChange)="onChangeUserOrFactory($event)"
            [disabled]="selectedTab() === 'Drop Off'"
          >
            <mat-button-toggle value="customer" id="remote-command-customer">
              Customer
            </mat-button-toggle>
            <mat-button-toggle value="allUser" id="remote-command-user">
              All User
            </mat-button-toggle>
            <mat-button-toggle
              value="allFactory"
              [attr.data-testid]="'remote-command-factory'"
              id="remote-command-factory"
              [ngClass]="{
                'factory-warning': (remoteCommandsService.userOrFactory$ | async) === 'allFactory',
              }"
            >
              All Factory
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      }
      <div class="remote-command__basicOrAdvanced">
        <mat-button-toggle-group
          [ngModel]="remoteCommandsService.basicOrAdvanced$ | async"
          (ngModelChange)="onChangeBasicOrAdvanced($event)"
          [disabled]="selectedTab() === 'Drop Off'"
        >
          <mat-button-toggle value="basic" id="remote-command-basic">Basic</mat-button-toggle>
          <mat-button-toggle
            value="advanced"
            [attr.data-testid]="'remote-command-advanced'"
            id="remote-command-advanced"
            >Advanced
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div [matTooltip]="sendTooltip()">
        <button
          mat-icon-button
          color="accent"
          (click)="onSendRemoteCommand()"
          [disabled]="
            !isSendEnabled || (!data?.isTerminal && validationService.state() !== 'valid')
          "
          [attr.data-testid]="'send-remote-command'"
          id="send-remote-command"
        >
          <mat-icon>send</mat-icon>
        </button>
      </div>

      @if (!data?.isTerminal) {
        @switch (validationService.state()) {
          @case ('loading') {
            <mat-spinner [diameter]="20" color="accent"></mat-spinner>
          }
          @case ('error') {
            <mat-icon [matTooltip]="validationService.errorMessage()" color="warn">info</mat-icon>
          }
          @case ('valid') {
            <mat-icon color="accent">check_circle</mat-icon>
          }
        }
      }
    }
  </ng-template>
</vectronic-card>
